<form (submit)="onFormSubmit($event)">
    <dx-form #formRef [formData]="formData" [colCount]="(screen.xSmallScreenChanged | async) ? 2 : colCount"
        labelLocation="left" [screenByWidth]="getSizeQualifier" (onFieldDataChanged)="onFieldChange(null,null,$event)">

        <dxi-item dataField="merchantId" editorType="dxSelectBox" [editorOptions]="{
            items: merchantList,
            displayExpr: 'CompanyName',
            valueExpr: 'Id',
            searchEnabled: true
        } "><dxo-label text="Merchant"></dxo-label>
            <dxi-validation-rule type="required" message="You must select merchant"></dxi-validation-rule>
        </dxi-item>

        <dxi-item dataField="amount" onValue [isRequired]="true" editorType="dxNumberBox"
            [editorOptions]="{
                showClearButton: true,
                format: 'R #,##0.00',
                value: formData.amount,
                valueChangeEvent: 'input',
                disabled: !merchantSelected,
                step : 0
              }">
            <dxo-label text="Amount"></dxo-label>
            <dxi-validation-rule type="required" message="Amount is required"></dxi-validation-rule>
            <dxi-validation-rule type="numeric" message="Amount must be a number."></dxi-validation-rule>
            <dxi-validation-rule type="range" [min]="0.1" message="Amount must be at least 0.1."></dxi-validation-rule>
        </dxi-item>

        <dxi-item>
            <dxo-label text="Service Fee"></dxo-label>
            <div>{{ formData.fee | currency:'R' }}</div>
        </dxi-item>

        <dxi-item>
            <div *dxTemplate style="text-align: right;">
                <dx-button [text]="submitButtonOptions.text!" [type]="submitButtonOptions.type!"
                    [width]="submitButtonOptions.width!" [useSubmitBehavior]="submitButtonOptions.useSubmitBehavior!"
                    [disabled]="submitButtonOptions.disabled || !formValid || formData.amount <= 0">
                </dx-button>
            </div>
        </dxi-item>
    </dx-form>
</form>
